import { render, staticRenderFns } from "./chapterCover.vue?vue&type=template&id=c98ae2f8"
import script from "./chapterCover.vue?vue&type=script&lang=js"
export * from "./chapterCover.vue?vue&type=script&lang=js"
import style0 from "./chapterCover.vue?vue&type=style&index=0&id=c98ae2f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports